<template>
  <div>
    <h2 class="c-card--orders__single__order-number">{{ $t('web.catalog_order_list.order_number', {order_number: order.short_order_id}) }}</h2>
    <p class="c-card--orders__single__item">
      <router-link class="t-link" :to="{ name: 'Single Reward', params: { id: order.reward_id}}">
        {{ order.reward_name }}
      </router-link>
    </p>
    <div class="c-card--orders__single__datagroup">
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.date') }}</dt>
        <dd class="c-card--orders__single__data__value">{{ order.created }}</dd>
      </dl>
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.points') }}</dt>
        <dd class="c-card--orders__single__data__value">
          <i class="fa fa-star t-points-icon"></i>
          {{ order.order_total }}
        </dd>
      </dl>
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.quantity') }}</dt>
        <dd class="c-card--orders__single__data__value">{{ order.item_quantity }}</dd>
      </dl>
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.updated') }}</dt>
        <dd class="c-card--orders__single__data__value">{{ order.updated }}</dd>
      </dl>
    </div>
    <div class="c-card--orders__single__datagroup">
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.order_status') }}</dt>
        <dd class="c-card--orders__single__data__value">
          <span class="c-status" :class="statusColor(order.order_status)">{{ order.order_status }}</span>
        </dd>
      </dl>
      <dl class="c-card--orders__single__data" v-if="!order.email_status">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.shipping_status') }}</dt>
        <dd class="c-card--orders__single__data__value">
          <span class="c-status" :class="statusColor(order.shipping_status)">{{ order.shipping_status }}</span>
        </dd>
      </dl>
      <dl class="c-card--orders__single__data" v-if="!order.email_status">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.tracking') }}</dt>
        <dd class="c-card--orders__single__data__value">
          {{ order.carrier_tracking }}
          <span class="c-card--orders__single__data__value__empty" v-if="!order.carrier_tracking">{{ $t('web.catalog_order_list.tracking_unavailable') }}</span>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RewardOpsOrderCard',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    statusColor (status) {
      status = status ? status.toLowerCase() : ''
      switch (status) {
        case 'pending':
          status = 't-alert-warning'
          break
        case 'processing':
          status = 't-alert-warning'
          break
        case 'partial':
          status = 't-alert-danger'
          break
        case 'rejected':
          status = 't-alert-danger'
          break
        case 'failed':
          status = 't-alert-danger'
          break
        case 'stopped':
          status = 't-alert-danger'
          break
        case 'cancelled':
          status = 't-alert-plain'
          break
        case 'sent':
          status = 't-alert-info'
          break
        case 'delivered':
          status = 't-alert-success'
          break
        case 'returned':
          status = 't-alert-success'
          break
        default:
          status = 't-alert-plain'
          break
      }
      return status
    }
  }
}
</script>



// WEBPACK FOOTER //
// RewardOpsOrderCard.vue?0ad95e5c